import styled from 'styled-components';

export const Wrapper = styled.div<{ isActive: boolean }>`
  border-bottom: 2px solid
    ${(props) => (props.isActive ? '#0081c6' : 'transparent')};
  transition: border-color 200ms ease-in;
  color: ${(props) => (props.isActive ? '#0081c6' : '#333f48')};
  font-size: 16px;
  line-height: 16px;

  &:hover {
    border-color: #0081c6;
    color: #0081c6;
  }

  a {
    display: block;
    color: ${(props) => (props.isActive ? '#0081c6' : '#333f48')};
    padding-bottom: 12px;
  }

  a:hover {
    border-color: #0081c6;
    color: #0081c6;
  }
`;
